














import Channel from '@/types/Channel.interface'
import Vue, { PropType } from 'vue'
import { VTooltip, VBtn, VIcon } from 'vuetify/lib';
export default Vue.extend({
    props: {
        item: {
            type: Object as PropType<Channel>,
            required: false,
        },
        itemId: {
            type: Number,
            required: false,
        },
        open: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    methods: {
        onChange(): void {
            this.$emit('onChange', this.item, this.itemId)
        }
    }
})
